import React, { useState } from "react";
import styled from "styled-components";


import { Solution1Card, Solution2Card, Solution3Card } from "../solution/solution_card.js";

const ResultBottomWrapper = styled.div`
  position: relative;
  width: 100%;
  left: 0px;

  margin-top: 30px;
  margin-bottom: 100px;

  display: flex;

  align-items: center;
  justify-content: center;
`;

// const solutionTitle = [
//     "최적의 주차장 요금제",
//     "내 주차장 주변 평균 주차요금",
//     "내 주차장 주변 지역 차량등록현황",
//   ];

// const solutionList = {
//     0: <TrafficFlow />,
//     1: <AvgFee />,
//     2: <VehicleNum />,
//   };

export default function Solutions() {
    return(
        <ResultBottomWrapper>
        <Solution1Card solutionNumber="1" title="최적의 주차장 요금제" text="내 주차장의 딱 맞는 요금제를 추천해드립니다." />
        <Solution2Card solutionNumber="2" title="최적의 정액제 대수" text="정액제 판매 수량을 추천해드립니다." />
        <Solution3Card solutionNumber="3" title="공대수" text=" 아직 준비중인 솔루션 입니다. " />
        </ResultBottomWrapper>
    );
}